




















import _ from 'lodash'
import {Component, Watch} from 'vue-property-decorator'
import BaseInput from '@/services/BaseInput'

@Component
export default class Checkbox extends BaseInput {
  public selected = this.value || this.getDefaultValue

  get getDefaultValue() {
    const value = _.head(this.options).value
    switch (typeof value) {
      case 'boolean':
        return this.value || false
      default:
        return this.options.length > 1
          ? this.value || []
          : this.value || ''
    }
  }

  @Watch('selected', { deep: true })
  public onSelected(newValue) {
    this.innerValue = newValue
  }
}
